import getCookieValue from './getCookieValue'
import util from './util'
var _img,
    _imgTest,
    id58 = encodeURIComponent(getCookieValue('id58')),
    sessionid = encodeURIComponent(getCookieValue('sessionid')),
    guid = function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8)
            return v.toString(16)
        })
    },
    uuid = '',
    cp = '',
    url = ''
function stat_anjuke(para) {
    uuid = guid()
    url = para.encryptUrl
    cp = decodeURIComponent(util.getQueryStringByPara(url, 'cp')).replace(/_UNIQID_/, uuid)
    // url = [url, '?guid=', id58, '&h=', encodeURIComponent(para.detailURL), '&r=', encodeURIComponent(location.href), '&t=', new Date().getTime(), '&ssid=', sessionid, '&uid=', id58, '&cp=', encodeURIComponent(cp)].join('');
    url = url
        .replace(/_PAGE_URL_/, encodeURIComponent(para.detailURL))
        .replace(/_PAGE_REFERER_URL_/, encodeURIComponent(location.href))
        .replace(/_SSID_/, sessionid)
        .replace(/_CLICK_TIME_/, new Date().getTime())
    url = util.setUrlParameter('cp', cp, url)
    
    _img = document.createElement('img')
    _img.src = url + '&requestID=' + uuid
    _img = null
    
    _imgTest = document.createElement('img')
    _imgTest.src = '//luna.58.com/list.shtml?plat=m&city=bj&cate=yewu&-15=20&tag=zhaopin_common_secondremen_yewu&PGTID=0d202408-0000-1a8a-aeda-20fa2ac37601&ClickID=1&ajk=cuiguozheng'
    _imgTest = null
    
    if (typeof para.cb === 'function') {
        para.cb(uuid)
    }
}
export default stat_anjuke

